import { lazy } from "react";
import { Settings } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

export const settingsFeature: FeatureDescriptor = {
  id: "settings",
  flag: "settings",
  path: "/settings",
  group: "admin",
  navKey: "nav.settings",
  icon: Settings,
  roles: ["admin"],
  element: lazy(() => import("./SettingsPage")),
};
